// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VersionComparisonStatistics } from './version-comparison-statistics';
import {
    VersionComparisonStatisticsFromJSON,
    VersionComparisonStatisticsFromJSONTyped,
    VersionComparisonStatisticsToJSON,
    VersionComparisonStatisticsToJSONTyped,
} from './version-comparison-statistics';
import type { VersionComparisonChangesInner } from './version-comparison-changes-inner';
import {
    VersionComparisonChangesInnerFromJSON,
    VersionComparisonChangesInnerFromJSONTyped,
    VersionComparisonChangesInnerToJSON,
    VersionComparisonChangesInnerToJSONTyped,
} from './version-comparison-changes-inner';

/**
 * 
 * @export
 * @interface VersionComparison
 */
export interface VersionComparison {
    /**
     * 
     * @type {number}
     * @memberof VersionComparison
     */
    base_version: number;
    /**
     * 
     * @type {Array<VersionComparisonChangesInner>}
     * @memberof VersionComparison
     */
    changes: Array<VersionComparisonChangesInner>;
    /**
     * 
     * @type {number}
     * @memberof VersionComparison
     */
    compare_version: number;
    /**
     * 
     * @type {VersionComparisonStatistics}
     * @memberof VersionComparison
     */
    statistics: VersionComparisonStatistics;
}

/**
 * Check if a given object implements the VersionComparison interface.
 */
export function instanceOfVersionComparison(value: object): value is VersionComparison {
    if (!('base_version' in value) || value['base_version'] === undefined) return false;
    if (!('changes' in value) || value['changes'] === undefined) return false;
    if (!('compare_version' in value) || value['compare_version'] === undefined) return false;
    if (!('statistics' in value) || value['statistics'] === undefined) return false;
    return true;
}

export function VersionComparisonFromJSON(json: any): VersionComparison {
    return VersionComparisonFromJSONTyped(json, false);
}

export function VersionComparisonFromJSONTyped(json: any, ignoreDiscriminator: boolean): VersionComparison {
    if (json == null) {
        return json;
    }
    return {
        
        'base_version': json['base_version'],
        'changes': ((json['changes'] as Array<any>).map(VersionComparisonChangesInnerFromJSON)),
        'compare_version': json['compare_version'],
        'statistics': VersionComparisonStatisticsFromJSON(json['statistics']),
    };
}

export function VersionComparisonToJSON(json: any): VersionComparison {
    return VersionComparisonToJSONTyped(json, false);
}

export function VersionComparisonToJSONTyped(value?: VersionComparison | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_version': value['base_version'],
        'changes': ((value['changes'] as Array<any>).map(VersionComparisonChangesInnerToJSON)),
        'compare_version': value['compare_version'],
        'statistics': VersionComparisonStatisticsToJSON(value['statistics']),
    };
}
